import { combineReducers } from '@reduxjs/toolkit'
import userstore from './modules/userstore'
import msgboxstore from './modules/msgboxstore'
import menustore from './modules/menustore'
import formstore from './modules/formstore'
import imgdlgstore from './modules/imagedlgstore'
import searchstore from './modules/searchliststore'
import tagsearchstore from './modules/tagsearchliststore'
import toolpanelstore from './modules/toolpanelstore'
import environstore from './modules/environstore'
import formdlgstore from './modules/formdlgstore'
import popuptextstore from './modules/popuptextstore'

const rootReducer = combineReducers({
    user: userstore.reducer,
    msgbox: msgboxstore.reducer,
    form: formstore.reducer,
    menu: menustore.reducer,
    imgdlg: imgdlgstore.reducer,
    search: searchstore.reducer,
    tagsearch: tagsearchstore.reducer,
    toolpnl: toolpanelstore.reducer,
    env: environstore.reducer,
    formdlg: formdlgstore.reducer,
    popuptext: popuptextstore.reducer
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer